import { isAndroidOnline } from "@/api/androidApi";
const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  isPcMode: (state) => state.app.isPcMode, // 判断是否为pc端
  isRoloadWs: (state) => state.app.isRoloadWs, // 判断是否重连ws
  isWsError: (state) => state.app.isWsError, //ws直接断开
  singleFinger: (state) => state.app.singleFinger, //是否单指
  visitedViews: (state) => state.tagsView.visitedViews, // 新增
  cachedViews: (state) => state.tagsView.cachedViews, // 新增
  roles: (state) => state.user.roles, // 路由
  permission_routes: (state) => state.permission.routes, // 路由
  name: (state) => state.user.name, // 路由
  token: (state) => state.user.token,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name
  userInfo: (state) => state.user.userInfo, // 个人信息
  routerList: (state) => state.user.routerList, // 路由页面

  // ------------ 数字软键盘
  keyboardShow: (state) => state.keyboard.keyboardShow, // 数字软键盘内容
  keyboardClass: (state) => state.keyboard.keyboardClass, // 动态类名
  keyboardInputVal: (state) => state.keyboard.keyboardInputVal, // 输入框内容
  keyboardMaxlength: (state) => state.keyboard.keyboardMaxlength, // 输入框限制长度
  inputEle: (state) => state.keyboard.inputEle, // 输入框ele

  // ------------ 建模部分
  /**
   * 建模部分
   */
  topBtnActive: (state) => state.platBtns.topBtnActive, // 所有建模按钮当前选中状态ID
  bottomBtnActive: (state) => state.platBtns.bottomBtnActive, // 右下角建模按钮当前选中状态ID
  moveBoxActive: (state) => state.platBtns.moveBoxActive, // 所有移动盒子当前显示状态ID组
  moveBoxId: (state) => state.platBtns.moveBoxId, // 所有移动盒子当前选中ID

  topBtns: (state) => state.platBtns.topBtns, // 头部按钮列表
  footerBtns: (state) => state.platBtns.footerBtns, // 底部按钮列表
  fixationShow: (state) => state.platBtns.fixationShow, // 固定表单显示状态
  moveFixationFrom: (state) => state.platBtns.moveFixationFrom, // 固定盒子-移动表单
  isAxisNaming: (state) => state.platBtns.isAxisNaming, // 当前在轴线命名中
  isCopyFloor: (state) => state.platBtns.isCopyFloor, // 当前在复制楼层中
  isMoveOrCopy: (state) => state.platBtns.isMoveOrCopy, // 当前在移动或复制中
  EditRead: (state) => state.platBtns.EditRead, // 固定表单显示状态
  axisIsShow: (state) => state.platBtns.axisIsShow, // 轴线（含命名）是否显示
  fontSize: (state) => state.platBtns.fontSize,

  isDeleteMarker: (state) => state.platBtns.isDeleteMarker, // 是否删除标记
  scaleShow: (state) => state.platBtns.scaleShow, // 是否显示比例尺
  ruleWidth: (state) => state.platBtns.ruleWidth, // 比例尺格数
  maxNum: (state) => state.platBtns.maxNum, // 比例尺最大值

  /**
   * 建模主要数据
   */
  initEntity: (state) => state.modelingData.initEntity, // 建模-主盒子

  /**
   * MX建模数据
   */
  rlProject_id: (state) => state.cadModules.rlProject_id, // 当前项目id
  rlProject_name: (state) => state.cadModules.rlProject_name, // 当前项目name
  rlBuilding: (state) => state.cadModules.rlBuilding, // 当前楼层ID

  MxInit: (state) => state.cadModules.MxInit, // 绘制基础数据
  MxLine: (state) => state.cadModules.MxLine, // 直线子类

  layerinformationAll: (state) => state.cadModules.layerinformationAll, // 层信息数据

  modelStrength: (state) => state.cadModules.modelStrength, // 强度设置

  tipCoord: (state) => state.cadModules.tipCoord, // 鼠标坐标

  moveDistObj: (state) => state.cadModules.moveDistObj, // 移动距离对象

  bgc: (state) => state.cadModules.bgc, // 背景颜色
  userList: (state) => state.cadModules.userList,
  applicationList: (state) => state.cadModules.applicationList,
  applicationShowDialogVisible: (state) =>
    state.cadModules.applicationShowDialogVisible,
  lock: (state) => state.cadModules.lock && !isAndroidOnline(), //如果是离线的话，强制不被锁住
  push_time: (state) => state.cadModules.push_time,
  isSaveLoading: (state) => state.cadModules.isSaveLoading,
  isSaveTips: (state) => state.cadModules.isSaveTips,
  /**
   * 检测数据
   */
  detectionShow: (state) => state.detectionModule.detectionShow, // 构件检测弹框盒子
  DragBoxShow: (state) => state.detectionModule.DragBoxShow, // 提示
  DragBoxText: (state) => state.detectionModule.DragBoxText, // 提示文字
  ModuleDrag: (state) => state.detectionModule.ModuleDrag, // 盒子位置/大小信息
  mosVal: (state) => state.detectionModule.mosVal, // 当前选中的检测项item
  changeFloorDisabled: (state) => state.detectionModule.changeFloorDisabled, // 楼层切换禁用
  calculateList: (state) => state.detectionModule.calculateList, // 计算书数据
  markShow: (state) => state.detectionModule.markShow, // 标记显示
  markInfoShow: (state) => state.detectionModule.markInfoShow, // 标记信息显示
  mxdrawClickId: (state) => state.detectionModule.mxdrawClickId, // mxdraw点击对象id
  // ---------- 重置数据
  // 建模
  rl_stdFlr_id: (state) => state.globalData.rl_stdFlr_id, // 当前标准层ID
  rl_wasm_module: (state) => state.globalData.rl_wasm_module, // wasm数据
  current_sel_ent: (state) => state.globalData.current_sel_ent, // 当前选中的实体对象
  rl_floor_arr: (state) => state.globalData.rl_floor_arr, // 当前自然层列表
  rl_stdFlr_arr: (state) => state.globalData.rl_stdFlr_arr, // 当前标准层列表
  revokeRollbackLength: (state) => state.globalData.revokeRollbackLength,
  isBldg: (state) => state.globalData.isBldg, // 是否整栋绘制
  revokeDataLength: (state) => state.globalData.revokeDataLength,
  menuData: (state) => state.globalData.menuData, // 菜单数据
  downMenuChickData: (state) => state.globalData.downMenuChickData, // 下方按钮点击的功能
  hiddenKeysForLeftBox: (state) => state.globalData.hiddenKeysForLeftBox, // 左侧隐藏的key
  hiddenKeysForRightBox: (state) => state.globalData.hiddenKeysForRightBox, // 右侧隐藏的key
  isSketch: (state) => state.globalData.isSketch, // 是否草图模式
  lockList: (state) => state.displayData.lockList, // 构件/非结构构件 锁定列表

  // 检测+检查
  rlProject_detail: (state) => state.cadModules.rlProject_detail, // 项目详情数据
  rl_floor_id: (state) => state.detectionModule.rl_floor_id, // 构件检测自然层Guid
  VisNmb: (state) => state.detectionModule.VisNmb, // 构件刷新次数/用来监听刷新数据
  calculateList: (state) => state.detectionModule.calculateList,
  btnDrawStatus: (state) => state.detectionModule.btnDrawStatus, // 绘图区域显示隐藏
  axisMeasureDatas: (state) => state.detectionModule.axisMeasureDatas, // 轴线测量选中尺寸对应的轴线guid
  inspectSummary: (state) => state.detectionModule.inspectSummary, // 检查汇总数据
  updateInspectSummary: (state) => state.detectionModule.updateInspectSummary, // 检查汇总状态
  leftMenuWidth: (state) => state.detectionModule.leftMenuWidth, // 左侧菜单宽度

  // 模型页面
  viewFlag: (state) => state.drawModules.viewFlag, // 二维/三维切换
  drawPlay: (state) => state.drawModules.drawPlay, // 绘图区域按钮切换禁用启用
  isSingleTouch: (state) => state.drawModules.isSingleTouch, // 单指触摸
  canDraw: (state) => state.drawModules.canDraw, // 当前是否可执行绘制
  // -----------------------------------------------  精简版数据存储

  TestPage: (state) => state.inspectionStore.TestPage, //  检测/调查页面数据
  rightMenuActive: (state) => state.inspectionStore.rightMenuActive, // 右侧菜单栏
  comMenuActive: (state) => state.inspectionStore.comMenuActive, // 构件菜单栏
  comShow: (state) => state.inspectionStore.comShow, // 构件菜单栏选中弹窗显
  partShow: (state) => state.inspectionStore.partShow, // 构件选中操作弹窗显隐
  AxisShow: (state) => state.inspectionStore.AxisShow, // 选择轴线弹出录入表显隐
  axisNamingShow: (state) => state.inspectionStore.axisNamingShow, // 轴线命名弹窗显隐
  rotateShow: (state) => state.inspectionStore.rotateShow, // 旋转操作弹窗显隐
  rotateAngleShow: (state) => state.inspectionStore.rotateAngleShow, // 旋转角度弹窗显隐
  bottomShow: (state) => state.inspectionStore.bottomShow, // 底部操作弹窗显隐
  generateShow: (state) => state.inspectionStore.generateShow, // 生成表格显隐
  crossGridShow: (state) => state.inspectionStore.crossGridShow, // 正交轴网弹窗显隐
  arcGridShow: (state) => state.inspectionStore.arcGridShow, // 弧形轴网弹窗显隐
  sketchChangeErrorShow: (state) => state.inspectionStore.sketchChangeErrorShow, // 草图线错误检查弹窗显隐
  setSketchShow: (state) => state.inspectionStore.setSketchShow, // 设置草图弹窗显隐
  setModelNoShow: (state) => state.inspectionStore.setModelNoShow, // 设置构件号弹窗显隐
  sketchChangeErrorData: (state) => state.inspectionStore.sketchChangeErrorData, // 草图线错误检查数据
  upperNodeHeightShow: (state) => state.inspectionStore.upperNodeHeightShow, // 上节点高弹窗显隐
  currentItem: (state) => state.inspectionStore.currentItem, // 生成表格显隐
  currentAxisType: (state) => state.inspectionStore.currentAxisType, // 当前绘制轴线的方式
  currentSketchType: (state) => state.inspectionStore.currentSketchType, // 当前绘制草图的方式
  //其他
  // 其他
  gridShowData: (state) => state.rlEntData.gridShowData, // 栅格实体数据
  isInCommand: (state) => state.inspectionStore.isInCommand, // 是否在命令中
  constructType: (state) => state.globalData.constructType, // 构件类型
  localUrlAndroid: (state) => state.app.localUrlAndroid, // 构件类型
  findIds: (state) => state.inspectionStore.findIds, // 当前高亮的id
  hasCrackGuid: (state) => state.rlEntData.hasCrackGuid, // 当前有裂缝的数据
  //是否在多选裂损中
  isCrackSelectIng: (state) => state.cadModules.isCrackSelectIng,
  isGountitleOrthogonalActive: (state) =>
    state.cadModules.isGountitleOrthogonalActive,
  //地下室层数
  undergroundNumber: (state) => state.cadModules.undergroundNumber,
};
export default getters;
